module.exports = __webpack_public_path__ + "static/media/ui_ux_design.f9757452.svg";